import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import useModalHistory from '../hooks/useModalHistory';

function MobileSheet({ open, onClose, title, children }) {
  const { colors } = useTheme();

  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  useModalHistory(open, onClose);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[200] sm:hidden" role="dialog" aria-modal="true" aria-label={title || 'Sheet'}>
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div
        className="absolute bottom-0 left-0 right-0 rounded-t-2xl max-h-[80vh] overflow-y-auto"
        style={{ background: `linear-gradient(135deg, ${colors.accent}40 0%, ${colors.accent}15 100%), ${colors.cardBg}`, border: `1px solid ${colors.accentBorder}` }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 pt-4 pb-2">
          {title && (
            <p className="text-[14px] font-semibold" style={{ color: colors.primaryText }}>{title}</p>
          )}
          <button
            onClick={onClose}
            aria-label="Close"
            className="ml-auto flex items-center justify-center w-8 h-8 rounded-full"
            style={{ backgroundColor: colors.inputBg, color: colors.secondaryText }}
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="px-4 pb-8">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MobileSheet;
